import { Modal } from 'flowbite-react';
import { useEffect, useState } from 'react';
import { getVehicleById } from '../../../../common/services/vehicles.api';
import { IVehicle } from '../../../../types/vehicle.type';
import Loading from '../../../../common/components/ui/loading/Loading';
import FormEditVehicle from '../forms/FormEditVehicle';

type Props = {
  vehicleId: string
  onClose?: () => void
  onSave: (vehicleId: string) => void
}

export default function ModalEditVehicle(props: Props) {
  const [vehicleData, setVehicleData] = useState<IVehicle | null>(null)

  useEffect(() => {
    async function loadVehicleData(vehicleId: string) {
      if (!vehicleId) return;

      const { data, ok } = await getVehicleById(vehicleId)
      if (ok) {
        setVehicleData(data as unknown as IVehicle)
      }
    }

    setVehicleData(null)

    if (props.vehicleId) loadVehicleData(props.vehicleId)

  }, [props.vehicleId])

  return (
    <Modal
      size={"5xl"}
      className='relative'
      show={true}
      onClose={() => props.onClose && props.onClose()}
    >
      <Modal.Header className='text-black'><h2 className='text-black'>{`Editando Veículo: ${(vehicleData || {})?.licensePlate}`}</h2></Modal.Header>
      <Modal.Body className='text-black'>
        {vehicleData ? (
          <FormEditVehicle onSave={(data) => (data)} data={vehicleData} />
        ) : <Loading />}
      </Modal.Body>
    </Modal>
  );
}
